import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uq-preloader"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "container auth-container"
}
const _hoisted_5 = { class: "container-form py-56 px-32 px-sm-56" }
const _hoisted_6 = { class: "h4 title mb-36 mb-sm-56 text-primary" }
const _hoisted_7 = {
  class: "text-danger text-start mt-8",
  role: "alert"
}
const _hoisted_8 = { class: "d-flex flex-column align-items-center flex-md-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_ctx.status === 'loading')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('Inicio de sesión')), 1),
          _createElementVNode("form", {
            id: "login",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
          }, [
            _createVNode(_component_v_form_group_input_text, {
              type: "email",
              class: "mb-40",
              value: _ctx.email,
              label: _ctx.$t('Correo'),
              "yup-errors-variable": _ctx.errors.email,
              autocomplete: "off",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"]),
            _createVNode(_component_v_form_group_input_text, {
              type: "password",
              class: "mb-56",
              value: _ctx.password,
              label: _ctx.$t('Contraseña'),
              "yup-errors-variable": _ctx.errors.password,
              autocomplete: "off",
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors.email, (error, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-0",
                      key: index
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["value", "label", "yup-errors-variable"]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: "btn btn-link-secondary fw-bold me-12 mb-24 mb-md-0 p-0",
                to: {name: 'forgot-password'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('He olvidado mi contraseña')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_button, {
                type: "submit",
                variant: "secondary",
                disabled: !_ctx.meta.valid || _ctx.accepted,
                "is-loading": _ctx.accepted,
                "aria-label": _ctx.$t('Iniciar sesión')
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Iniciar sesión')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "is-loading", "aria-label"])
            ])
          ], 32)
        ])
      ]))
}